//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Toggle from '~/components/Toggle/Toggle.vue';
import bottomHero from '~/components/HomePage/elements/BottomHero';
import intercomBubble from '~/components/IntercomBubble/IntercomBubble';

export default {
  components: {
    'an-toggle': Toggle,
    bottomHero,
    intercomBubble,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timeInPage: 1,
      intercomBubbleId: null,
      showIntercomBubble: false,
      intercomBubbleContact: 'anima',
      intercomBubbleMessage:
        'Hi 👋<br />We have a special offer for September only!<br /><b>50% off the first 3 months</b>, click here to redeem',
      timeoutIds: [],
      isAnnual: true,
      isMobile: false,
      isPricingScreenFlowActive: false,
    };
  },
  computed: {
    columns() {
      const columns = this.blok.columns;
      const freePlan = this.getPlanByName('Free');
      const proPlan = this.getPlanByName('Pro');
      const teamPlan = this.getPlanByName('Team');
      const businessPlan = this.getPlanByName('Business');

      let screenRelevantColumns = [freePlan, proPlan, teamPlan, businessPlan];

      if (process.client && window?.innerWidth < 1070) {
        screenRelevantColumns = [businessPlan, proPlan, teamPlan, freePlan];
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isMobile = true;
      }
      if (screenRelevantColumns.some((item) => !item)) return columns;

      return screenRelevantColumns;
    },
  },
  mounted() {
    this.$intercom('boot');
    this.checkTimeZoneFeatures();
    this.timeoutIds.push(
      setTimeout(this.promptIntercomBubble, this.timeInPage * 1000)
    );
  },

  beforeDestroy() {
    this.clearTimeouts();
    this.$intercom('shutdown');
    this.hideIntercomBubble();
  },
  methods: {
    getPlanByName(name) {
      return this.blok.columns.find(({ planName }) => planName === name);
    },
    async checkTimeZoneFeatures() {
      const featureName = 'tz.show.pricing-screen-based-flow';
      const date = new Date();
      const offset = date.getTimezoneOffset();
      const hour = (-1 * offset) / 60;
      const params = {
        hour,
        feature: featureName,
      };
      const resp = await this.$animaapi.get('/get_time_zone_feature_flags', {
        params,
      });
      const experiments = {};
      Object.entries(resp.data || {}).map(
        ([feature, enabled]) => (experiments[feature] = enabled === 'TRUE')
      );
      if (experiments[featureName]) {
        localStorage.setItem('pricingScreenFlowActive', true);
      }
      const pricingScreenFlowActive = localStorage.getItem('pricingScreenFlowActive');
      this.isPricingScreenFlowActive = !!(pricingScreenFlowActive || experiments[featureName]);
    },
    trackIdleTime({ timeInPage }) {
      this.$tracking.trackEvent('website.page.idle', {
        timeInPage,
        screenWidth: window?.innerWidth,
        page: 'pricing',
      });
    },
    promptIntercomBubble() {
      if (new Date() < new Date('2021-10-01')) {
        const { timeInPage } = this;
        this.showIntercomBubble = true;
        this.trackIdleTime({ timeInPage });
      }
    },
    hideIntercomBubble() {
      this.showIntercomBubble = false;
    },
    clearTimeouts() {
      for (const id of this.timeoutIds) {
        clearTimeout(id);
      }
    },
    goToWebappPayment() {
      window.location.href =
        'https://projects.animaapp.com/payment?plan=pro&interval=monthly&promo_code=sep-2021-offer';
    },
    trackContactUs() {
      this.$tracking.trackEvent('pricing.contact-us.click');
    },
  },
};
